//IMAGE PASSIONS
import PassionDecoration from '../assets/passion-decoration.png';
import PassionGame from '../assets/passion-game.png';
import PassionMultitasking from '../assets/passion-multitasking.png';
import PassionSeries from '../assets/passion-series.png';
import PassionSports from '../assets/passion-sports.png';

// IMAGE FEATURES
import Decoration1 from '../assets/features/decoration/leve-seu-entretenimento-com-voce.png';
import Decoration2 from '../assets/features/decoration/Incondicionalmente-bela.png';
import Decoration3 from '../assets/features/decoration/tv-tambem-na-vertical.png';
import Decoration4 from '../assets/features/decoration/tv-que-e-uma-obra-de-arte.png';

// Game
import Game1 from '../assets/features/game/direto-no-console.png';
import Game2 from '../assets/features/game/direto-no-pc.png';
import Game3 from '../assets/features/game/direto-na-tv.png';

// Homeoffice
import HomeOffice1 from '../assets/features/homeoffice/controle-sua-casa-pela-tv.png';
import HomeOffice2 from '../assets/features/homeoffice/conteudo-aprimorado-em-8k.png';
import HomeOffice3 from '../assets/features/homeoffice/video-conferencia-com-multitela.png';

// Moovies
// import Moovies1 from '../assets/features/moovies/seus-titulos-favoritos-em-resolucao-8k.png';
// import Moovies2 from '../assets/features/moovies/mais-brilho-contraste-e-cores-vibrantes.png';
// import Moovies3 from '../assets/features/moovies/audio-imersivo-e-alta-fidelidade-de-cor.png';
// import Moovies4 from '../assets/features/moovies/detalhes-e-fluidez-em-cada-movimento.png';
import Moovies1 from '../assets/features/moovies/a-melhor-tv-qualidade.png';
import Moovies2 from '../assets/features/moovies/recursos-avancados.png';
import Moovies3 from '../assets/features/moovies/tecnologia-experiencia.png';
import Moovies4 from '../assets/features/moovies/custo-beneficio.png';


// Sports:
// import Sports1 from '../assets/features/sports/viva-emocao-esportes-em-resolucao-8k.png';
// import Sports2 from '../assets/features/sports/mais-brilho-contraste-e-cores-vibrantes.png';
// import Sports3 from '../assets/features/sports/audio-imersivo-e-alta-fidelidade-de-cor.png';
// import Sports4 from '../assets/features/sports/detalhes-e-fluidez-em-cada-movimento.png';
import Sports1 from '../assets/features/sports/a-melhor-tv-qualidade.png';
import Sports2 from '../assets/features/sports/recursos-avancados.png';
import Sports3 from '../assets/features/sports/tecnologia-experiencia.png';
import Sports4 from '../assets/features/sports/custo-beneficio.png';

// All Features:
import AllFeatures from '../assets/features/all-features/all-features.png';

const passions =  [
  {
      title: "sports",
      displayName: "Assistir à\n esportes",
      analytics: 'btn_esporte',
      adobeAnalyticsPassions: 'assistir-a-esportes',
      image: {
          src: PassionSports,
          alt: "Jogo de futebol americano"
      },
      // sizeStageTVImage: "//images.samsung.com/is/image/samsung/p6pim/img/vd/helpmechoose/img-vd-helpmechoose-2021-help-me-choose-size-on-screen-passion-02-sports-69936084",
      // defaultSize: "85",
      // recommendedSize: "85",
      // defaultResolution: "4K",
      // recommendedResolution: "4K",
      // defaultStyle: "standard",
      // recommendedStyle: "standard",
      // defaultColor: null,
      // recommendedColor: null,
      featuresByPassion: [
          {
              name: "8K",
              breadcrumbName:"A melhor 8K",
              description: "A melhor TV 8K do mercado\n em uma tela sem limites",
              analytics: 'btn_titulos_8k',
              adobeAnalyticsFeatures: 'resolucao-8k',
              // subDescription: [
              //   "Resolução de imagem 8K",
              //   "Tecnologia Quantum MiniLED|Tecnologia exclusiva da Samsung, que substitui o LED convencional por 40 Mini LEDs, tornando o preto muito mais preciso e o brilho perfeito, trazendo mais realismo ao conteúdo assistido",
              //   "Áudio com até 90W e 6.2.4 canais",
              // ],
              subDescription: [
                "Neo QLED 8K com Painel MiniLED|Tecnologia exclusiva da Samsung, que substitui o LED convencional por 40 Mini LEDs, tornando o preto muito mais preciso e o brilho perfeito, trazendo mais realismo ao conteúdo assistido",
                "Som de cinema com até 90W",
              ],
              image: Sports1,
              priceScale: 5,
              // default: false,
              // recommended: false,
              highlights: [
                "thickness",
                "border",
                "singleConnection",
                "resolution",
                "colorVolume",
                "contrast",
                "brightness",
                "processor",
                "frequency",
                "movingSound",
                "soundPower"
            ]
          },
          {
              name: "vividColor",
              breadcrumbName:"A melhor 4K",
              description: "A melhor experiência 4K, com\n revolução de contraste e brilho",
              analytics: 'btn_mais_brilho',
              adobeAnalyticsFeatures: 'mais-brilho',
              // subDescription: [
              //   "Resolução de imagem 4K",
              //   "Tecnologia Quantum MiniLED|Tecnologia exclusiva da Samsung, que substitui o LED convencional por 40 Mini LEDs, tornando o preto muito mais preciso e o brilho perfeito, trazendo mais realismo ao conteúdo assistido",
              //   "Áudio com até 60W e 4.2.2 canais"
              // ],
              subDescription: [
                "Neo QLED 4K com Painel MiniLED|Tecnologia exclusiva da Samsung, que substitui o LED convencional por 40 Mini LEDs, tornando o preto muito mais preciso e o brilho perfeito, trazendo mais realismo ao conteúdo assistido",
                "Som imersivo com até 60W"
              ],
              image: Sports2,
              priceScale: 4,
              // default: false,
              // recommended: false,
              highlights: [
                "thickness",
                "resolution",
                "colorVolume",
                "contrast",
                "brightness",
                "processor",
                "frequency",
                "movingSound",
                "soundPower"
            ]
          },
          {
              name: "immersiveSound",
              breadcrumbName:"Brilho/cores fiéis",
              description: "TV 4K com brilho e cores fiéis e\n duráveis, e design moderno",
              analytics: 'btn_audio_cor',
              adobeAnalyticsFeatures: 'audio-imersivo',
              // subDescription: [
              //   "Resolução de imagem 4K",
              //   "Tecnologia Quantum LED|100% do volume de cor para desfrutar ao máximo da qualidade de imagem em 4K, com 1 bilhão de cores vibrantes por muito mais tempo",
              //   "Áudio com até 60W e 2.2.2 canais"
              // ],
              subDescription: [
                "QLED 4K|100% do volume de cor para desfrutar ao máximo da qualidade de imagem em 4K, com 1 bilhão de cores vibrantes por muito mais tempo",
                "Som potente com até 60W"
              ],
              image: Sports3,
              priceScale: 3,
              // default: false,
              // recommended: false,
              highlights: [
                "resolution",
                "colorVolume",
                "contrast",
                "brightness",
                "processor",
                "frequency",
                "movingSound",
                "soundPower"
            ]
          },
          {
              name: "smootherMotion",
              breadcrumbName:"Melhor custo-benefício",
              description: "TV para assistir em 4K com\n excelente custo-benefício",
              analytics: 'btn_detalhes_fluidez',
              adobeAnalyticsFeatures: 'detalhes-e-fluidez',
              // subDescription: [
              //   "Resolução de imagem 4K",
              //   "Tecnologia LED|O processador Crystal 4K transforma tudo a que você assiste em resolução próxima à 4K, com cores puras e reais",
              //   "Áudio com 20W e 2 canais"
              // ],
              subDescription: [
                "Crystal 4K|O processador Crystal 4K transforma tudo a que você assiste em resolução próxima à 4K, com cores puras e reais",
                "Som ambiente com até 20W"
              ],
              image: Sports4,
              priceScale: 2,
              // default: false,
              // recommended: false,
              highlights: [
                "thickness",
                "resolution",
                "colorVolume",
                "contrast",
                "brightness",
                "processor",
                "frequency",
                "movingSound",
                "soundPower"
            ]
          }
      ],
      myTVSubHeadlineByPassion: "Confira a TV ideal para você."
  },
  {
      title: "movies",
      displayName: "Assistir à\n filmes e séries",
      analytics: 'btn_filmes',
      adobeAnalyticsPassions: 'assistir-a-filmes-e-series',
      image: {
          src: PassionSeries,
          alt: "Cena de um filme com cavaleiros de armadura portando espadas"
      },
      // sizeStageTVImage: "//images.samsung.com/is/image/samsung/p6pim/img/vd/helpmechoose/img-vd-helpmechoose-2021-help-me-choose-size-on-screen-passion-01-movies-shows-69936082",
      // defaultSize: "75",
      // recommendedSize: "75",
      // defaultResolution: "8K",
      // recommendedResolution: "8K",
      // defaultStyle: "standard",
      // recommendedStyle: "standard",
      // defaultColor: null,
      // recommendedColor: null,
      featuresByPassion: [
          {
              name: "8K",
              breadcrumbName:"A melhor 8K",
              description: "A melhor TV 8K do mercado\n em uma tela sem limites",
              analytics: 'btn_titulos_8k',
              adobeAnalyticsFeatures: 'resolucao-8k',
              subDescription: [
                "Neo QLED 8K com Painel MiniLED|Tecnologia exclusiva da Samsung, que substitui o LED convencional por 40 Mini LEDs, tornando o preto muito mais preciso e o brilho perfeito, trazendo mais realismo ao conteúdo assistido",
                "Som de cinema com até 90W",
              ],
              image: Moovies1,
              priceScale: 5,
              // default: false,
              // recommended: false,
              highlights: [
                "thickness",
                "border",
                "singleConnection",
                "resolution",
                "colorVolume",
                "contrast",
                "brightness",
                "processor",
                "frequency",
                "movingSound",
                "soundPower"
            ]
          },
          {
              name: "vividColor",
              breadcrumbName:"A melhor 4K",
              description: "A melhor experiência 4K, com\n revolução de contraste e brilho",
              analytics: 'btn_mais_brilho',
              adobeAnalyticsFeatures: 'mais-brilho',
              // subDescription: [
              //   "Resolução de imagem 4K",
              //   "Tecnologia Quantum MiniLED|Tecnologia exclusiva da Samsung, que substitui o LED convencional por 40 Mini LEDs, tornando o preto muito mais preciso e o brilho perfeito, trazendo mais realismo ao conteúdo assistido",
              //   "Áudio com até 60W e 4.2.2 canais"
              // ],
              subDescription: [
                "Neo QLED 4K com Painel MiniLED|Tecnologia exclusiva da Samsung, que substitui o LED convencional por 40 Mini LEDs, tornando o preto muito mais preciso e o brilho perfeito, trazendo mais realismo ao conteúdo assistido",
                "Som imersivo com até 60W"
              ],
              image: Moovies2,
              priceScale: 4,
              // default: false,
              // recommended: false,
              highlights: [
                "thickness",
                "resolution",
                "colorVolume",
                "contrast",
                "brightness",
                "processor",
                "frequency",
                "movingSound",
                "soundPower"
            ]
          },
          {
              name: "immersiveSound",
              breadcrumbName:"Brilho/cores fiéis",
              description: "TV 4K com brilho e cores fiéis e\n duráveis, e design moderno",
              analytics: 'btn_audio_cor',
              adobeAnalyticsFeatures: 'audio-imersivo',
              // subDescription: [
              //   "Resolução de imagem 4K",
              //   "Tecnologia Quantum LED|100% do volume de cor para desfrutar ao máximo da qualidade de imagem em 4K, com 1 bilhão de cores vibrantes por muito mais tempo",
              //   "Áudio com até 60W e 2.2.2 canais"
              // ],
              subDescription: [
                "QLED 4K|100% do volume de cor para desfrutar ao máximo da qualidade de imagem em 4K, com 1 bilhão de cores vibrantes por muito mais tempo",
                "Som potente com até 60W"
              ],
              image: Moovies3,
              priceScale: 3,
              // default: false,
              // recommended: false,
              highlights: [
                "resolution",
                "colorVolume",
                "contrast",
                "brightness",
                "processor",
                "frequency",
                "movingSound",
                "soundPower"
            ]
          },
          {
              name: "smootherMotion",
              breadcrumbName:"Melhor custo-benefício",
              description: "TV para assistir em 4K com\n excelente custo-benefício",
              analytics: 'btn_detalhes_fluidez',
              adobeAnalyticsFeatures: 'detalhes-e-fluidez',
              // subDescription: [
              //   "Resolução de imagem 4K",
              //   "Tecnologia LED|O processador Crystal 4K transforma tudo a que você assiste em resolução próxima à 4K, com cores puras e reais",
              //   "Áudio com 20W e 2 canais"
              // ],
              subDescription: [
                "Crystal 4K|O processador Crystal 4K transforma tudo a que você assiste em resolução próxima à 4K, com cores puras e reais",
                "Som ambiente com até 20W"
              ],
              image: Moovies4,
              priceScale: 2,
              // default: false,
              // recommended: false,
              highlights: [
                "thickness",
                "resolution",
                "colorVolume",
                "contrast",
                "brightness",
                "processor",
                "frequency",
                "movingSound",
                "soundPower"
            ]
          }
      ],
      myTVSubHeadlineByPassion: "Confira a TV ideal para você."
  },
  {
      title: "gaming",
      displayName: "Jogar\n Videogame",
      analytics: 'btn_videogame',
      adobeAnalyticsPassions: 'jogar-videogame',
      image: {
          src: PassionGame,
          alt: "Carro de corrida Formula 1 em uma curva, dentro de um jogo de video game"
      },
      // sizeStageTVImage: "//images.samsung.com/is/image/samsung/p6pim/img/vd/helpmechoose/img-vd-helpmechoose-2021-help-me-choose-size-on-screen-passion-03-gaming-69936088",
      // defaultSize: "75",
      // recommendedSize: "75",
      // defaultResolution: "4K",
      // recommendedResolution: "4K",
      // defaultStyle: "standard",
      // recommendedStyle: "standard",
      // defaultColor: null,
      // recommendedColor: null,
      featuresByPassion: [
          {
              name: "console",
              breadcrumbName:"No Console",
              description: "No Console",
              analytics: 'btn_console',
              adobeAnalyticsFeatures: 'console',
              subDescription: [
                "Jogue com seu console predileto",
              ],
              image: Game1,
              // default: false,
              // recommended: false,
              highlights: [
                "contrast",
                "brightness",
                "frequency",
                "hdmi",
                "dolbyAtmos",
                "movingSound",
                "soundPower"
            ]
          },
          {
              name: "pc",
              breadcrumbName:"No PC",
              description: "No PC",
              analytics: 'btn_pc',
              adobeAnalyticsFeatures: 'pc',
              subDescription: [
                "Jogue com seu PC em uma tela grande de até 144Hz",
              ],
              image: Game2,
              // default: false,
              // recommended: false,
              highlights: [
                "contrast",
                "brightness",
                "frequency",
                "hdmi",
                "dolbyAtmos",
                "movingSound",
                "soundPower"
            ]
          },
          {
              name: "cloud",
              breadcrumbName:"Direto na TV",
              description: "Direto na TV",
              analytics: 'btn_direto_tv',
              adobeAnalyticsFeatures: 'direto-na-tv',
              subDescription: [
                "Use o Samsung Gaming Hub e jogue direto da nuvem",
              ],
              image: Game3,
              // default: false,
              // recommended: false,
              highlights: [
                "colorVolume",
                "contrast",
                "brightness",
                "processor",
                "frequency",
                "freesync",
                "hdmi",
                "dolbyAtmos",
                "soundPower"
            ]
          }
      ],
      myTVSubHeadlineByPassion: "Confira a TV ideal para você."
  },
  {
      title: "design",
      displayName: "Decoração e\n estilo",
      analytics: 'btn_deco',
      adobeAnalyticsPassions: 'decoracao-e-estilo',
      image: {
          src: PassionDecoration,
          alt: "Sala de estar com sofá e uma mesa ao meio com decorações"
      },
      // sizeStageTVImage: null,
      // defaultSize: "75",
      // recommendedSize: "75",
      // defaultResolution: "4K",
      // recommendedResolution: "4K",
      // defaultStyle: null,
      // recommendedStyle: null,
      // defaultColor: null,
      // recommendedColor: null,
      featuresByPassion: [
          {
              name: "masterpiece",
              breadcrumbName:"TV para obras primas",
              description: "TV que é uma obra de arte",
              analytics: 'btn_tv_arte',
              adobeAnalyticsFeatures: 'obra-de-arte',
              subDescription: [
                "Perfeita para as suas obras-primas",
              ],
              image: Decoration4,
              // default: false,
              // recommended: false,
              highlights: [
                "displayMasterpiece",
                "beautiful",
                "vertical",
                "portable",
                "resolution",
                "colorVolume",
                "brightness",
                "processor",
                "alexa",
                "bixby",
                "googleduo"
            ]
          },
          {
              name: "iconic",
              breadcrumbName:"Incondicionalmente bela",
              description: "Incondicionalmente bela",
              analytics: 'btn_bela',
              adobeAnalyticsFeatures: 'incondicionalmente-bela',
              subDescription: [
                "Design perfeito de frente, de lado e até na parte de trás, para que você a coloque onde preferir",
              ],
              image: Decoration2,
              // default: false,
              // recommended: false,
              highlights: [
                "displayMasterpiece",
                "beautiful",
                "vertical",
                "portable",
                "resolution",
                "colorVolume",
                "brightness",
                "processor",
                "movingSound",
                "soundPower",
                "alexa",
                "bixby",
                "googleduo"
            ]
          },
          {
              name: "vertical",
              breadcrumbName:"TV também na vertical",
              description: "TV também na vertical",
              analytics: 'btn_tv_vertical',
              adobeAnalyticsFeatures: 'tv-na-vertical',
              subDescription: [
                "Aproveite o entretenimento do seu celular na TV, rotacionando a tela também para o formato vertical",
              ],
              image: Decoration3,
              // default: false,
              // recommended: false,
              highlights: [
                "displayMasterpiece",
                "beautiful",
                "vertical",
                "portable",
                "resolution",
                "colorVolume",
                "brightness",
                "processor",
                "movingSound",
                "soundPower",
                "alexa",
                "bixby",
                "googleduo"
            ]
          },
          {
              name: "projector",
              breadcrumbName:"Pra levar junto, portátil",
              description: "Leve seu entretenimento com você",
              analytics: 'btn_entret_vc',
              adobeAnalyticsFeatures: 'projetor',
              subDescription: [
                "Design portátil, leve e com rotação 180°",
              ],
              image: Decoration1,
              // default: false,
              // recommended: false,
              highlights: [
                "displayMasterpiece",
                "beautiful",
                "vertical",
                "portable",
                "resolution",
                "colorVolume",
                "processor",
                "movingSound",
                "soundPower",
                "alexa",
                "bixby",
                "handsfree",
                "googleduo"
            ]
          }
      ],
      myTVSubHeadlineByPassion: "Confira a TV ideal para você."
  },
  {
      title: "smart",
      displayName: "Multitarefa e\n home office",
      analytics: 'btn_home_office',
      adobeAnalyticsPassions: 'multitarefa-e-home-office',
      image: {
          src: PassionMultitasking,
          alt: "Uma montanha com uma praia com ondas em sua base"
      },
      // sizeStageTVImage: "//images.samsung.com/is/image/samsung/p6pim/img/vd/helpmechoose/img-vd-helpmechoose-2021-help-me-choose-size-on-screen-passion-05-smart-tv-69936090",
      // defaultSize: "65",
      // recommendedSize: "65",
      // defaultResolution: null,
      // recommendedResolution: null,
      // defaultStyle: null,
      // recommendedStyle: null,
      // defaultColor: null,
      // recommendedColor: null,
      featuresByPassion: [
          {
              name: "smarthome",
              breadcrumbName:"Controle sua casa pela TV",
              description: "Controle sua casa pela TV",
              analytics: 'btn_controle_casa',
              adobeAnalyticsFeatures: 'controle-casa-pela-tv',
              subDescription: [
                "Sua TV como central de automação de seu ambiente com o aplicativo SmartThings ou assistente de voz preferido",
              ],
              image: HomeOffice1,
              // default: false,
              // recommended: false,
              highlights: [
                "displayMasterpiece",
                "colorVolume",
                "contrast",
                "brightness",
                "processor",
                "handsfree",
                "googleduo",
                "smartcam"
            ]
          },
          {
              name: "smart8K",
              breadcrumbName:"Conteúdo aprimorado em 8K",
              description: "Conteúdo aprimorado em 8K",
              analytics: 'btn_conteudo_8k',
              adobeAnalyticsFeatures: 'conteudo-aprimorado-em-8k',
              subDescription: [
                "O processador que só a Samsung tem aprimora qualquer conteúdo para resolução próxima ao 8K",
              ],
              image: HomeOffice2,
              // default: false,
              // recommended: false,
              highlights: [
                "border",
                "contrast",
                "brightness",
                "movingSound",
                "soundPower"
            ]
          },
          {
              name: "videocall",
              breadcrumbName:"Vídeo conferência com multi tela",
              description: "Vídeo conferência com multi tela",
              analytics: 'btn_multi_tela',
              adobeAnalyticsFeatures: 'video-conferencia-multi-tela',
              subDescription: [
                "Divida a tela de sua TV e veja conteúdos diferentes simultaneamente",
              ],
              image: HomeOffice3,
              // default: false,
              // recommended: false,
              highlights: [
                "displayMasterpiece",
                "contrast",
                "brightness",
                "processor",
                "frequency",
                "soundPower",
                "handsfree",
                "smartcam"
            ]
          }
      ],
      myTVSubHeadlineByPassion: "Confira a TV ideal para você."
  },
  {
    title: "todos",
    displayName: "Todas as \n atividades",
    analytics: 'btn_todos',
    adobeAnalyticsPassions: 'todos',
    image: {
        src: AllFeatures,
        alt: "Todos"
    },
    // sizeStageTVImage: "//images.samsung.com/is/image/samsung/p6pim/img/vd/helpmechoose/img-vd-helpmechoose-2021-help-me-choose-size-on-screen-passion-02-sports-69936084",
    // defaultSize: "85",
    // recommendedSize: "85",
    // defaultResolution: "4K",
    // recommendedResolution: "4K",
    // defaultStyle: "standard",
    // recommendedStyle: "standard",
    // defaultColor: null,
    // recommendedColor: null,
    featuresByPassion: [
      {
        name: "smarthome",
        breadcrumbName:"Controle sua casa pela TV",
        description: "Controle sua casa pela TV",
        analytics: 'btn_controle_casa',
        adobeAnalyticsFeatures: 'controle-casa-pela-tv',
        subDescription: [
          "Sua TV como central de automação de seu ambiente com o aplicativo SmartThings ou assistente de voz preferido",
        ],
        image: HomeOffice1,
        // default: false,
        // recommended: false,
        highlights: [
          "displayMasterpiece",
          "colorVolume",
          "contrast",
          "brightness",
          "processor",
          "handsfree",
          "googleduo",
          "smartcam"
        ]
      },
    ],
    myTVSubHeadlineByPassion: "Todos"
},
];

export default passions;